module.exports = __webpack_public_path__ + "img/productie.99516c21.svg";